import React from "react";
import Followup from "./FollowUp/Followup";
import { NewTab, PageTab } from "../../../components";
import { useModuleAccess } from "../../../hooks";

const FollowupInterview = () => {
  const followupMenus = [
    {
      title: "Interview follow-up",
      page: <Followup />,
      type: "main",
      id: "followupinterviews_interviewfollowup",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: followupMenus,
    parentId: "followupinterviews",
  });
  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="followup-interviews"
    />
  );
};

export default FollowupInterview;
